import { PracticeMappingHandler } from '../../../mappings/practices';

export class D4WPracticeMappingHandler extends PracticeMappingHandler {}
